/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { JudgingState } from './JudgingState';
import {
    JudgingStateFromJSON,
    JudgingStateFromJSONTyped,
    JudgingStateToJSON,
    JudgingStateToJSONTyped,
} from './JudgingState';
import type { CompetitorMemberRead } from './CompetitorMemberRead';
import {
    CompetitorMemberReadFromJSON,
    CompetitorMemberReadFromJSONTyped,
    CompetitorMemberReadToJSON,
    CompetitorMemberReadToJSONTyped,
} from './CompetitorMemberRead';

/**
 * One competitor's standing in an event; the points fields are None under feedback none.
 * 
 * `problem_points` has a key only for a problem the competitor has a judged submission for; an
 * absent key means not attempted (it contributes 0 to `total`), while 0 is a judged 0.
 * `judging` has a key for each problem whose newest submission of the competitor has no points
 * yet: `failed` once it is older than the judging threshold, else `pending` (#247), also beside
 * points from an earlier submission; None when no problem has one, and under feedback none,
 * like the points.
 * @export
 * @interface ResultRow
 */
export interface ResultRow {
    /**
     * 
     * @type {number}
     * @memberof ResultRow
     */
    rank?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResultRow
     */
    total?: number | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ResultRow
     */
    problem_points?: { [key: string]: number; } | null;
    /**
     * 
     * @type {{ [key: string]: JudgingState; }}
     * @memberof ResultRow
     */
    judging?: { [key: string]: JudgingState; } | null;
    /**
     * 
     * @type {string}
     * @memberof ResultRow
     */
    competitor_id: string;
    /**
     * 
     * @type {string}
     * @memberof ResultRow
     */
    competitor_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResultRow
     */
    organization_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResultRow
     */
    organization_name?: string | null;
    /**
     * 
     * @type {Array<CompetitorMemberRead>}
     * @memberof ResultRow
     */
    members?: Array<CompetitorMemberRead>;
}

/**
 * Check if a given object implements the ResultRow interface.
 */
export function instanceOfResultRow(value: object): value is ResultRow {
    if (!('competitor_id' in value) || value['competitor_id'] === undefined) return false;
    return true;
}

export function ResultRowFromJSON(json: any): ResultRow {
    return ResultRowFromJSONTyped(json, false);
}

export function ResultRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultRow {
    if (json == null) {
        return json;
    }
    return {
        
        'rank': json['rank'] == null ? undefined : json['rank'],
        'total': json['total'] == null ? undefined : json['total'],
        'problem_points': json['problem_points'] == null ? undefined : json['problem_points'],
        'judging': json['judging'] == null ? undefined : (mapValues(json['judging'], JudgingStateFromJSON)),
        'competitor_id': json['competitor_id'],
        'competitor_name': json['competitor_name'] == null ? undefined : json['competitor_name'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'members': json['members'] == null ? undefined : ((json['members'] as Array<any>).map(CompetitorMemberReadFromJSON)),
    };
}

export function ResultRowToJSON(json: any): ResultRow {
    return ResultRowToJSONTyped(json, false);
}

export function ResultRowToJSONTyped(value?: ResultRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rank': value['rank'],
        'total': value['total'],
        'problem_points': value['problem_points'],
        'judging': value['judging'] == null ? undefined : (mapValues(value['judging'], JudgingStateToJSON)),
        'competitor_id': value['competitor_id'],
        'competitor_name': value['competitor_name'],
        'organization_id': value['organization_id'],
        'organization_name': value['organization_name'],
        'members': value['members'] == null ? undefined : ((value['members'] as Array<any>).map(CompetitorMemberReadToJSON)),
    };
}

